import ApiService from './api';
import logger from '../utils/logger';

const buildQueryString = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      search.append(key, value);
    }
  });
  const query = search.toString();
  return query ? `?${query}` : '';
};

const unwrap = (response, fallback = {}) => {
  if (!response) return fallback;
  if (response.data) return response.data;
  return response;
};

const PhotoLibraryService = {
  async list(params = {}) {
    try {
      const query = buildQueryString(params);
      const response = await ApiService.get(`/admin/photos${query}`);
      return unwrap(response, { items: [], total: 0, page: 1, pageSize: params.limit || 24 });
    } catch (error) {
      logger.error('[PhotoLibraryService] Failed to fetch photos:', error);
      throw error;
    }
  },

  async upload(formData) {
    if (!(formData instanceof FormData)) {
      throw new Error('FormData payload is required for photo uploads');
    }
    try {
      const response = await ApiService.post('/admin/photos', formData);
      return unwrap(response, {});
    } catch (error) {
      logger.error('[PhotoLibraryService] Photo upload failed:', error);
      throw error;
    }
  },

  async remove(photoId) {
    if (!photoId) {
      throw new Error('photoId is required');
    }
    try {
      const response = await ApiService.delete(`/admin/photos/${photoId}`);
      return unwrap(response, {});
    } catch (error) {
      logger.error('[PhotoLibraryService] Failed to delete photo:', error);
      throw error;
    }
  }
};

export default PhotoLibraryService;
